import { CodebookModel } from 'app/shared/model/shared.model';

export interface ConstructionFeeModel {
  iban: string;
  model: string;
  referralNumber: string;
  constructionFeeAmount: CodebookModel[];
  calculatedConstructionFeeAmount: number;
  specialFee: CodebookModel[];
  estimatedConstructionCost: CodebookModel[];
  specialConstructionCommencementFee: number;
}

export const constructionFeeInitial = {
  iban: '',
  model: '',
  referralNumber: '',
  constructionFeeAmount: [],
  calculatedConstructionFeeAmount: null,
  specialFee: [],
  estimatedConstructionCost: [],
  specialConstructionCommencementFee: null
};
